import { PropsWithChildren } from "react";
import { StiggProvider } from "@stigg/react-sdk";
import "@stigg/react-sdk/dist/styles.css";
import { defaultAppHost } from "../api/api";
import useGetOrganization from "../api/useGetOrganization";
import { developmentPublicApiKey, productionPublicApiKey, themeDark, themeLight } from "../settings/stigg";
import useThemeStore from "../stores/useThemeStore";
import { checkIsEmailVerified } from "../utils/verification";
import { useSessionContext } from "supertokens-auth-react/recipe/session";

export default function StiggProviderWrapper({ children }: PropsWithChildren<{}>) {
  const sessionContext = useSessionContext() as any;
  const { doesSessionExist, invalidClaims } = sessionContext;
  const isEmailVerified = checkIsEmailVerified(doesSessionExist, invalidClaims);

  const isProduction = window.location.hostname === defaultAppHost;
  const { data: organization } = useGetOrganization(!isEmailVerified);

  const theme = useThemeStore((state) => state.theme);

  return (
    <StiggProvider
      customerId={organization?.id}
      apiKey={isProduction ? productionPublicApiKey : developmentPublicApiKey}
      theme={theme === "dark" ? themeDark : themeLight}>
      {children}
    </StiggProvider>
  );
}
